export default __webpack_public_path__ + "static/media/editing.0feb62f9.png";